import YatungButton from '@Src/_basic/components/YatungButton';
import PreviousIcon from '@Src/_basic/icons/Previous';
import SaveIcon from '@Src/_basic/icons/Save';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  onSubmit: () => void;
  onGoBack: () => void;
}

export default function ThirdPartyAccountFormActions(props: Props) {
  const { t: i18T } = useTranslation();
  const { onSubmit, onGoBack } = props;

  return (
    <>
      <YatungButton
        text={i18T('USERSMANAGEMENU.EDIT_ACCOUNT.PREVIOUS')}
        color={'red'}
        variant="contained"
        size="large"
        onClick={onGoBack}
        startIcon={<PreviousIcon />}
        width={120}
      />
      <YatungButton
        text={i18T('USERSMANAGEMENU.EDIT_ACCOUNT.SAVE')}
        variant="contained"
        size="large"
        onClick={onSubmit}
        startIcon={<SaveIcon />}
        color={'blue'}
        width={120}
      />
    </>
  );
}
